'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  font-size: ', ';\n  background-color: ', ';\n  border: 1px solid\n    ', ';\n  color: ', ';\n  line-height: ', ';\n  padding: ', ' ', ';\n  ', '\n  position: relative;\n  ', '\n  cursor: inherit;\n  display: inline-block;\n  font-weight: ', ';\n  max-width: 100%;\n  overflow: hidden;\n\n  /* Applies spacing between inner elements (ex. text and icon) */\n  > * + * {\n    margin-left: ', ';\n  }\n\n  /* Applies spacing between sibling UITags */\n  & + & {\n    margin-left: ', ';\n  }\n\n  ', '\n'], ['\n  font-size: ', ';\n  background-color: ', ';\n  border: 1px solid\n    ', ';\n  color: ', ';\n  line-height: ', ';\n  padding: ', ' ', ';\n  ', '\n  position: relative;\n  ', '\n  cursor: inherit;\n  display: inline-block;\n  font-weight: ', ';\n  max-width: 100%;\n  overflow: hidden;\n\n  /* Applies spacing between inner elements (ex. text and icon) */\n  > * + * {\n    margin-left: ', ';\n  }\n\n  /* Applies spacing between sibling UITags */\n  & + & {\n    margin-left: ', ';\n  }\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  max-width: 100%;\n  vertical-align: top;\n'], ['\n  display: inline-flex;\n  max-width: 100%;\n  vertical-align: top;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  overflow: hidden;\n'], ['\n  overflow: hidden;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  bottom: 0;\n  color: currentColor;\n  margin-bottom: auto;\n  margin-top: auto;\n  position: absolute;\n  right: ', ';\n  top: 0;\n  transform: scale(0.5);\n'], ['\n  bottom: 0;\n  color: currentColor;\n  margin-bottom: auto;\n  margin-top: auto;\n  position: absolute;\n  right: ', ';\n  top: 0;\n  transform: scale(0.5);\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  && {\n    font-weight: ', ';\n    overflow: hidden;\n    text-decoration: underline;\n  }\n'], ['\n  && {\n    font-weight: ', ';\n    overflow: hidden;\n    text-decoration: underline;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Functions = require('../core/Functions');

var _LightColors = require('../core/LightColors');

var _LightColors2 = _interopRequireDefault(_LightColors);

var _MediumColors = require('../core/MediumColors');

var _MediumColors2 = _interopRequireDefault(_MediumColors);

var _NormalColors = require('../core/NormalColors');

var _NormalColors2 = _interopRequireDefault(_NormalColors);

var _Style = require('../core/Style');

var _underscore = require('../utils/underscore');

var _passthroughProps = require('../utils/propTypes/passthroughProps');

var _passthroughProps2 = _interopRequireDefault(_passthroughProps);

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _UILink = require('../link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UITruncateString = require('../text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _colors = require('HubStyleTokens/colors');

var _misc = require('HubStyleTokens/misc');

var _sizes = require('HubStyleTokens/sizes');

var _theme = require('HubStyleTokens/theme');

var _Styles = require('../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var USE_CLASSES = {
  // These do not come from the sketch file
  default: 'tag-default private-tag--disabled private-tag--default',
  primary: 'tag-primary private-tag--disabled',
  info: 'tag-info private-tag--info',

  disabled: 'private-tag--disabled',
  success: 'tag-success private-tag--success',
  warning: 'tag-warning private-tag--warning',
  danger: 'tag-danger private-tag--danger',

  calypso: 'private-tag--calypso',
  sorbet: 'private-tag--sorbet',
  lorax: 'private-tag--lorax',
  marigold: 'private-tag--marigold',
  'candy-apple': 'private-tag--candy-apple',
  norman: 'private-tag--norman',
  thunderdome: 'private-tag--thunderdome',
  oz: 'private-tag--oz',
  olaf: 'private-tag--olaf',

  'chart-red': 'private-tag--chart-red',
  'chart-orange': 'private-tag--chart-orange',
  'chart-yellow': 'private-tag--chart-yellow',
  'chart-green': 'private-tag--chart-green',
  'chart-aqua': 'private-tag--chart-aqua',
  'chart-blue': 'private-tag--chart-blue',
  'chart-purple': 'private-tag--chart-purple',
  'chart-dark-purple': 'private-tag--chart-dark-purple'
};

var STATUS_ALIAS_MAP = {
  paused: 'disabled',
  draft: 'disabled',
  active: 'success',
  sent: 'success',
  published: 'success',
  inReview: 'warning',
  scheduled: 'warning',
  removed: 'danger',
  cancelled: 'danger',
  error: 'danger'
};

var USE_COLOR_ALIAS_MAP = {
  // defaults
  disabled: 'default',
  paused: 'default',
  draft: 'default',
  primary: 'default',
  // oz
  success: 'oz',
  active: 'oz',
  sent: 'oz',
  published: 'oz',
  // marigold
  warning: 'marigold',
  inReview: 'marigold',
  scheduled: 'marigold',
  // cand-apple
  danger: 'candy-apple',
  removed: 'candy-apple',
  cancelled: 'candy-apple',
  error: 'candy-apple',
  // calypso
  info: 'calypso'
};

var TAG_BACKGROUND_COLORS = _extends({}, _LightColors2.default, {
  default: _colors.KOALA
});
var TAG_IS_BORDERED_BORDER_COLORS = _extends({}, _MediumColors2.default, {
  default: _colors.BATTLESHIP
});
var TAG_BORDER_COLORS = _extends({}, _NormalColors2.default, {
  default: _colors.BATTLESHIP
});

var getBackgroundColor = function getBackgroundColor(use) {
  return TAG_BACKGROUND_COLORS[use] != null ? TAG_BACKGROUND_COLORS[use] : _colors.KOALA;
};

var getBorderColor = function getBorderColor(use, bordered) {
  if (bordered && TAG_IS_BORDERED_BORDER_COLORS[use] != null) {
    return TAG_IS_BORDERED_BORDER_COLORS[use];
  } else if (TAG_BORDER_COLORS[use] != null) {
    return TAG_BORDER_COLORS[use];
  }
  return 'transparent';
};

var getInlineStyles = function getInlineStyles(inline) {
  return inline ? '\n        margin: 0 4px;\n        vertical-align: bottom;\n        \n        & + & {\n          margin-left: 4px;\n        }\n      ' : null;
};

var getCloseablePadding = function getCloseablePadding(closeable) {
  return closeable ? '\n        padding-right: 28px !important;\n      ' : null;
};

var Tag = _styledComponents2.default.span.withConfig({
  displayName: 'UITag__Tag'
})(_templateObject, _sizes.TAG_FONT_SIZE, function (props) {
  return getBackgroundColor(props.computedUse);
}, function (props) {
  return getBorderColor(props.computedUse, props._bordered);
}, function (props) {
  return props.computedUse === 'olaf' ? _colors.OLAF : _theme.BASE_FONT_COLOR;
}, (0, _Style.remCalc)(parseInt(_sizes.TAG_HEIGHT, 10) - 2), _sizes.TAG_PADDING_Y, _sizes.TAG_PADDING_X, function (props) {
  return getCloseablePadding(props.closeable);
}, (0, _Styles.setUserSelect)('none'), _misc.WEB_FONT_DEMI_BOLD_WEIGHT, (0, _Style.remCalc)(_sizes.TAG_ICON_SPACING_X), (0, _Style.remCalc)(_sizes.BASE_SPACING_X), function (props) {
  return getInlineStyles(props.inline);
});

var FlexWrapper = _styledComponents2.default.span.withConfig({
  displayName: 'UITag__FlexWrapper'
})(_templateObject2);

var ContentWrapper = _styledComponents2.default.span.withConfig({
  displayName: 'UITag__ContentWrapper'
})(_templateObject3);

var StyledCloseButton = (0, _styledComponents2.default)(_UICloseButton2.default).withConfig({
  displayName: 'UITag__StyledCloseButton'
})(_templateObject4, (0, _Style.remCalc)(6));

var StyledLink = (0, _styledComponents2.default)(_UILink2.default).withConfig({
  displayName: 'UITag__StyledLink'
})(_templateObject3);
StyledLink.displayName = 'StyledUILink';

var LinkStyledClickable = (0, _styledComponents2.default)(_UIClickable2.default).withConfig({
  displayName: 'UITag__LinkStyledClickable'
})(_templateObject5, _misc.WEB_FONT_MEDIUM_WEIGHT);
LinkStyledClickable.displayName = 'StyledUIClickable';

var UITag = _react2.default.createClass({
  displayName: 'UITag',

  propTypes: {
    children: _react.PropTypes.any,
    className: _react.PropTypes.string,
    closeable: _react.PropTypes.bool.isRequired,
    href: _react.PropTypes.string,
    target: _react.PropTypes.string,
    inline: _react.PropTypes.bool.isRequired,
    multiline: _react.PropTypes.bool.isRequired,
    onClick: _react.PropTypes.func,
    onCloseClick: _react.PropTypes.func,
    style: _react.PropTypes.object,
    truncateStringProps: (0, _passthroughProps2.default)(_UITruncateString2.default),
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES).concat(Object.keys(STATUS_ALIAS_MAP))).isRequired,
    _avatar: _react.PropTypes.node, // for UIAvatarTag
    _bordered: _react.PropTypes.bool, // for MultiSelect
    _onCloseMouseDown: _react.PropTypes.func // for MultiSelectValue
  },

  getDefaultProps: function getDefaultProps() {
    return {
      _bordered: false,
      closeable: false,
      inline: false,
      multiline: false,
      use: 'default'
    };
  },
  getClassName: function getClassName(_ref) {
    var _bordered = _ref._bordered,
        className = _ref.className,
        closeable = _ref.closeable,
        inline = _ref.inline,
        use = _ref.use;

    var computedUse = STATUS_ALIAS_MAP[use] || use;
    return (0, _classNames2.default)('tag', 'private-tag', className, USE_CLASSES[computedUse], {
      'private-tag--bordered': _bordered,
      'private-tag--has-close': closeable,
      'private-tag--inline': inline
    });
  },
  handleCloseClick: function handleCloseClick(evt) {
    var onCloseClick = this.props.onCloseClick;

    (0, _Functions.callIfPossible)(onCloseClick, evt);
  },
  renderCloseButton: function renderCloseButton(_ref2) {
    var closeable = _ref2.closeable,
        describedBy = _ref2.describedBy;

    if (closeable) {
      return _react2.default.createElement(StyledCloseButton, {
        'aria-describedby': describedBy,
        className: 'private-tag__close',
        onClick: this.handleCloseClick,
        onMouseDown: this.props._onCloseMouseDown
      });
    }

    return null;
  },
  renderContents: function renderContents(_ref3, _ref4) {
    var href = _ref3.href,
        target = _ref3.target,
        onClick = _ref3.onClick;
    var truncatedChildren = _ref4.truncatedChildren;

    var buttonClassName = 'private-tag__link';
    if (href) {
      return _react2.default.createElement(
        StyledLink,
        {
          className: buttonClassName,
          href: href,
          target: target,
          use: 'on-bright'
        },
        truncatedChildren
      );
    } else if (onClick) {
      return _react2.default.createElement(
        LinkStyledClickable,
        { className: buttonClassName, onClick: onClick },
        truncatedChildren
      );
    }

    return _react2.default.createElement(
      ContentWrapper,
      { className: 'private-tag__content-wrapper' },
      truncatedChildren
    );
  },
  render: function render() {
    var _props = this.props,
        _avatar = _props._avatar,
        _bordered = _props._bordered,
        children = _props.children,
        className = _props.className,
        closeable = _props.closeable,
        href = _props.href,
        inline = _props.inline,
        multiline = _props.multiline,
        onClick = _props.onClick,
        __onCloseClick = _props.onCloseClick,
        __onCloseMouseDown = _props._onCloseMouseDown,
        target = _props.target,
        truncateStringProps = _props.truncateStringProps,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['_avatar', '_bordered', 'children', 'className', 'closeable', 'href', 'inline', 'multiline', 'onClick', 'onCloseClick', '_onCloseMouseDown', 'target', 'truncateStringProps', 'use']);

    this._id = this._id || (0, _underscore.uniqueId)('Tag');

    var computedUse = USE_COLOR_ALIAS_MAP[use] || use;

    var renderedCloseButton = this.renderCloseButton({
      closeable: closeable,
      describedBy: this._id
    });

    var truncatedChildren = multiline ? children : _react2.default.createElement(
      _UITruncateString2.default,
      _extends({ useFlex: true }, truncateStringProps),
      children
    );

    return _react2.default.createElement(
      Tag,
      _extends({
        className: this.getClassName({
          _bordered: _bordered,
          className: className,
          closeable: closeable,
          inline: inline,
          use: use
        }),
        'data-component-name': 'UITag',
        id: this._id,
        computedUse: computedUse,
        _bordered: _bordered,
        closeable: closeable,
        inline: inline
      }, rest),
      _react2.default.createElement(
        FlexWrapper,
        { className: 'private-tag__flex-wrapper' },
        _avatar,
        this.renderContents({ href: href, target: target, onClick: onClick }, { truncatedChildren: truncatedChildren })
      ),
      renderedCloseButton
    );
  }
});

UITag.STATUS_ALIAS_MAP = STATUS_ALIAS_MAP;

exports.default = UITag;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/tag/UITag.js
// module id = 502
// module chunks = 2 3